import { useCallback, useEffect, useState } from "react";
import { Auth } from "shared/@auth/Auth";
import { ENVIRONMENT_CONFIG } from "shared/globals";
import createNotification from "shared/@utils/createNotification";

export function useAmwayDetails(iboNumber) {
  const { makeAuthedRequest } = Auth.useContainer();

  const [amwayData, setAmwayData] = useState(null);
  const [iboInfo, setIboInfo] = useState(null);
  const [amwayDetailsLoading, setAmwayDetailsLoading] = useState(false);

  const fetchAmwayDetails = useCallback(async () => {
    if (!iboNumber) {
      setAmwayData(null);
      setIboInfo(null);
      return;
    }

    setAmwayDetailsLoading(true);

    try {
      const [amwayRes, iboRes] = await Promise.all([
        makeAuthedRequest(`/v1/membership/amway/${iboNumber}`),
        makeAuthedRequest(`/v1/membership/ibo/${iboNumber}`),
      ]);

      if (!amwayRes.ok) {
        throw new Error("Failed to load Amway details.");
      }

      if (!iboRes.ok) {
        throw new Error("Failed to load IBO information.");
      }

      const [amwayJson, iboJson] = await Promise.all([
        amwayRes.json(),
        iboRes.json(),
      ]);

      setAmwayData(amwayJson);
      setIboInfo(iboJson);
    } catch (error) {
      setAmwayData(null);
      setIboInfo(null);

      createNotification({
        type: "danger",
        title: "Amway Details",
        message: error.message,
        autoDismiss: true,
      });
    } finally {
      setAmwayDetailsLoading(false);
    }
  }, [iboNumber, makeAuthedRequest]);

  useEffect(() => {
    fetchAmwayDetails();
  }, [fetchAmwayDetails]);

  return {
    amwayData,
    iboInfo,
    amwayDetailsLoading,
    refetchAmwayDetails: fetchAmwayDetails,
  };
}
